
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatSort } from '@angular/material/sort';
//import { ContentAuthoringService } from "../../services/content-authoring.service";
import { CourseService } from "../../services/course.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-course-view-user',
  templateUrl: './course-view-user.component.html',
  styleUrls: ['./course-view-user.component.scss']
})
export class CourseViewUserComponent implements OnInit {
  adminData: any; courseId: any = ''; viewUsersDetail: any; cousesData: any = []; courseForm: any = []; userID: any = '';
  course_id: any; searchText: any = ''; order: any = ''; order_by: any = 'asc'; filter_by_org: any = ''; submitted = false
  assessment_id: any; request_status: number = 0; reject_reason: string = "";tab:any='';


  constructor(private modalService: NgbModal, private router: Router,
    private spinner: NgxSpinnerService, private authCours: CourseService, private route: ActivatedRoute, private contentAuthoringApi: ContentAuthoringService) { }

  // rejectForm = new FormGroup({
  //   txtRemark: new FormControl('',[Validators.required] ),
  // });
  // get f() { return this.rejectForm.controls; } 

  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  opens(content: any, userId: any) {
    this.userID = userId;
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  viewUserProgress(courseId: any, searchText: any, order: any, order_by: any, filter_by_org: any) {
    this.spinner.show();
    this.authCours.viewUsersProgress(courseId, searchText, order, order_by, filter_by_org).subscribe(
      (data) => {
        console.log(data);
        if (data.status == 200) {
          this.viewUsersDetail = data.courseData;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      (error) => {
        this.spinner.hide();
      },
    );
  }
  /****** start create duplicate course */
  duplicateCourse() {
    /*****get couse detail ****/
    this.authCours.CourseDetail(this.courseId).subscribe(
      data => {
        this.cousesData = data.courseData;
        this.courseForm = {
          "course_desc": data.courseData.course_desc,
          "course_id": "",
          "course_image": data.courseData.course_image,
          "course_name": data.courseData.course_name + '_copy',
          //"course_status": data.courseData.course_status,
          "course_status": 1,
          "created_by": data.courseData.db_created_dttm,
          "end_date": data.courseData.db_end_date,
          "is_active": data.courseData.is_active
        }
        this.authCours.dublicateCourse(this.courseForm).subscribe(
          (data) => {
            if (this.cousesData.courseModules.length > 0 && data.status == 201) {
              this.getModuleData(data.course_id);
            } else {
              document.getElementById('closelId')?.click();
              this.spinner.hide();
              this.router.navigate(['/courses']);
            }
          }, error => { })
      })
  }
 
  getModuleData(courseId: any) {
    if (this.cousesData && this.cousesData.courseModules) {
      let arr: Array<any> = this.cousesData.courseModules;
      arr.forEach((element,i) => {
        setTimeout(() => {
        let qts = element.subModules;
        for (let n = 0; n < qts.length; n++) {
          qts[n]['course_id'] = courseId;
          qts[n]['created_dttm'] = qts[n].db_created_dttm;
          qts[n]['created_by'] = qts[n].db_created_by;
        }
        element['course_id'] = courseId;
        element['created_dttm'] = element.db_created_dttm;
        element['created_by'] = element.db_created_by;
        element['subModules'] = qts;
        if(this.cousesData.courseModules.length-1==i){
          this.duplicateModule(element,1);
        }else{
          this.duplicateModule(element,0);
        }
      }, i*2000);
      })
     // this.spinner.hide();
    }
  }
  /*****create duplicate modules of course */
  duplicateModule(Modueldata: any,status:any) {
    this.authCours.creatModule(Modueldata, 'create').subscribe(
      data => {
        if(status==1){
          this.router.navigate(['/courses']);
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
       })
    
  }
  /****** END create duplicate course */

  // viewUsersDataBySearch(courseId: any, search_by: any) {
  
  //   this.authCours.ViewUsers(courseId, search_by).subscribe(
  //     (data) => {
  //       if (data.status == 200) {
  //         this.viewUsersDetail = data.courseData;
  //       }
  //     },
  //     (error) => {
  //     },
  //   );
  // }
  search(event: any) {
   
    this.searchText = event.target.value;
    this.viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);
  }
  DeAssignUser(userID: any) {
    this.authCours.DeAssignUsers(this.courseId, userID).subscribe(
      (data) => {
        if (data.status == 200) {
         // this.router.navigate(['/courses_view_user'], { queryParams: {courseId: this.courseId} });
          this.viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);
          document.getElementById('closelId')?.click();
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(is_active: any) {
    this.authCours.changeIsActiveVal(this.courseId, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.viewUserProgress(this.course_id, this.searchText, this.order, this.order_by, this.filter_by_org);
        } else {
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
      this.tab = queryParams['tab'];
    });
    if (this.courseId != '' && this.courseId != null)
      this.viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);
  }
  onSelect(event: any) {
    this.filter_by_org = event.target.value;
    this.viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);
  }
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order = sort.active;
      this.order_by = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order = sort.active;
      this.order_by = 'ASC';
    } else {
      this.order = '';
      this.order_by = 'DESC';
    }
    this.viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);
  };
  acceptRejectCourses(userID: number, course_id: any, assessment_id: any, request_status: any, reject_reason: any) {
    this.spinner.show();
    this.contentAuthoringApi.ViewCoursesAcceptReject(userID, course_id, assessment_id, request_status, reject_reason).subscribe(
      data => {
        console.log(data)
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      }
    )
  }
  openReject(content: any, data: any) {
    console.log(data);
    this.userID = data.user_id
    // this.userID = this.adminData.userID
    // this.course_id=data.course_id
    this.assessment_id = data.assessment_id,
      this.request_status = 3
    this.acceptRejectCourses(this.userID, this.courseId, this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' });

  }
  openAccept(content: any, data: any) {
    console.log(data);
    this.userID = data.user_id
    //this.course_id=data.course_id
    this.assessment_id = data.assessment_id,
      this.request_status = 2
    this.acceptRejectCourses(this.userID, this.courseId, this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' });

  }
  secondsToHms(d: any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h + ' hr ' + m + ' min';
  }
  // onSubmit(rejectForm: any) {
  //   this.submitted = true;
  //   if(this.rejectForm.invalid) { this.spinner.hide(); return; }
  //   this.reject_reason= this.rejectForm.controls.txtRemark.value;
  //   this.acceptRejectCourses(this.userID,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
  //   this.rejectForm.reset();
  //   this.modalService.dismissAll();
  //   //document.getElementById('close')?.click();
  //   this.viewUserProgress(this.courseId, this.searchText, this.order, this.order_by, this.filter_by_org);
  //  }

}
